import { ListItemCard } from "pages/components/ListItemCard/";
import { useNavigation } from "@refinedev/core";
import { AvatarPreview } from "./AvatarPreview";
import { ContactResponse, VoiceProfileResponse } from "../../types";

export const AvatarPreviewCard = ({
  contact,
  organizationId,
  currentlyPlayingVoice,
  setCurrentlyPlayingVoice,
}: {
  contact: ContactResponse;
  organizationId?: string;
  currentlyPlayingVoice?: VoiceProfileResponse;
  setCurrentlyPlayingVoice: (voice?: VoiceProfileResponse) => void;
}) => {
  const { edit } = useNavigation();
  const { firstname, lastname } = contact;
  const { face_profile, voice_profile } = contact?.presenter ?? {};
  const contactName = `${firstname} ${lastname}`;

  return (
    <ListItemCard
      title={contactName}
      onEditClick={() => edit("media_contacts", contact?.id)}
      recordId={contact.id}
      resource={`media/${organizationId}/contacts`}
    >
      <AvatarPreview
        avatar={face_profile}
        voice={voice_profile as VoiceProfileResponse}
        organizationId={organizationId}
        currentlyPlayedVoice={currentlyPlayingVoice}
        setCurrentlyPlayedVoice={setCurrentlyPlayingVoice}
      />
    </ListItemCard>
  );
};
